export const getGoogleAnalyticsIds = async (): Promise<{
  googleAnalyticsClientId: any
  googleAnalyticsSessionId: any
}> => {
  return new Promise((resolve) => {
    const result = getIds()

    if (result) {
      resolve(result)
      return
    }

    let count = 0
    const intervalId = setInterval(() => {
      const result = getIds()
      if (result) {
        resolve(result)
        clearInterval(intervalId)
      }

      count++
      console.log('count', count)
      if (count >= 8) {
        clearInterval(intervalId)
        // TODO: fix typing
        resolve(null as any)
      }
    }, 250)
  })
}

const getIds = () => {
  if (typeof window === 'undefined') {
    return null
  }

  if (!(window as any).GAClientData) return null

  return {
    googleAnalyticsClientId: (window as any).GAClientData?.clientId,
    googleAnalyticsSessionId: (window as any).GAClientData?.sessionId,
  }
}
